/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */
export function isWeekend(date: Date) {
  const weekday = date.getDay();
  return weekday === 0 || weekday === 6;
}
